import { render, staticRenderFns } from "./TravellerTemplateModify.vue?vue&type=template&id=0142515f"
import script from "./TravellerTemplateModify.vue?vue&type=script&lang=js"
export * from "./TravellerTemplateModify.vue?vue&type=script&lang=js"
import style0 from "./TravellerTemplateModify.vue?vue&type=style&index=0&id=0142515f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports